import { render } from "./AdjacencyMatrix.vue?vue&type=template&id=2bfd92a4"
import script from "./AdjacencyMatrix.vue?vue&type=script&lang=ts"
export * from "./AdjacencyMatrix.vue?vue&type=script&lang=ts"
script.render = render

export default script